import React, { PureComponent, PropTypes } from 'react'
import { connect } from 'react-redux'
import NotificationSystem from 'react-notification-system'
import { notify } from './NotifierActions'

class NotifierComponent extends PureComponent {

  componentWillReceiveProps(nextProps) {
    const { notification } = nextProps.notifications
    if (notification) {
      this.system().addNotification(notification)
    }
  }

  system = () => (
      this.refs.notificationSystem
  )

  render() {
    return (
      <div>
        <NotificationSystem ref="notificationSystem" style={false} noAnimation={false} />
      </div>
    )
  }
}

NotifierComponent.propTypes = {
  notifications: PropTypes.object,

  dispatchNotify: PropTypes.func
}

const mapStateToProps = state => ({
  notifications: state.notifications
})

const mapDispatchToProps = (dispatch) => (
  {
    dispatchNotify: (notification) => {
      dispatch(notify(notification))
    }
  }
)

export default connect(mapStateToProps, mapDispatchToProps)(NotifierComponent)



// WEBPACK FOOTER //
// ./src/components/notifier/NotifierComponent.js